import _ from 'underscore'
import Backbone from 'backbone'
import UserViewTemplate from '../templates/user.tpl'
import user from '../user'
import EditUserView from './edit-user'

const UserView = Backbone.View.extend({
    tagName: 'li',
    id: 'user-view',
    events: {
        'click .edit': 'editUser',
    },
    initialize() {
        this.template = _.template(UserViewTemplate)
        this.listenTo(this.model, 'change', this.render)
    },
    render() {
        let showEdit = false

        // IF the user is teacher AND role is not super-admin enable edit
        if (this.model.get('type').get('name') === 'teacher' &&
            this.model.get('role').get('name') !== 'super admin') {
            showEdit = true
        }

        // IF the user is student enable edit
        if (this.model.get('type').get('name') === 'student') {
            showEdit = true
        }

        // IF the user is a super admin enable all edit buttons
        if (user.get('role').get('name') === 'super admin') {
            showEdit = true
        }

        // add template data to the model
        const model = this.model.toJSON()
        model.showEdit = showEdit
        model.requiresApproval = this.model.get('role').get('name') === null &&
            this.model.get('type').get('name') === 'teacher'
        model.showPurchased = this.model.get('purchased').purchased()

        this.$el.html(this.template(model))
        return this
    },
    editUser(event) {
        const editUserView = new EditUserView({model: this.model})
        Backbone.$('#form-wrapper').html(editUserView.render().el)
        event.stopPropagation()
    }
})

export default UserView
